<template>
    <section class="main-section">
        <v-content>
            <v-container fluid fill-height>
                <v-layout>
                    <slot></slot>
                </v-layout>
            </v-container>
        </v-content>
    </section>
</template>

<script>
export default {
    name: 'LoginLayout'
}
</script>
